export enum ErrorType {
  /**
   * When a part of the application, e.g. a micro-frontend couldn't be loaded.
   */
  LOAD = 'LOAD',
  /**
   * When a page couldn't be found.
   */
  NOT_FOUND = 'NOT_FOUND',
  /**
   * When the server returns an error.
   */
  GENERIC = 'GENERIC',
}

export type Error = {
  title: string;
  body: string;
  image: string;
  button?: {
    text: string;
    url: string;
  };
};
